import { useAuthStore } from '@/stores/authStore';

import { StudentHome } from './student-home';
import { TeacherDashboard } from './teacher-dashboard';

/** 工作台首页：按角色分发到教师工作台 / 学生首页 */
export function DashboardPage() {
  const user = useAuthStore((state) => state.user);
  return user?.role === 'student' ? <StudentHome /> : <TeacherDashboard />;
}
